<script>
    import { ethStore, selectedAccount, web3, chainId } from "svelte-web3";;
    import config from "../config";
    
    const Web3Modal = window.Web3Modal.default;
    const WalletConnectProvider = window.WalletConnectProvider.default;

    // Connects via modal popup which allows user to select wallet
    const connectViaModal = async () => {
      let web3Modal = new Web3Modal({
        theme: "dark",
        cacheProvider: false,
        providerOptions: {
          walletconnect: {
            package: WalletConnectProvider,
            options: {
              infuraId: config.infuraKey,
            },
          },
        },
        disableInjectedProvider: false,
      });
      const provider = await web3Modal.connect();
      await ethStore.setProvider(provider);
    };
  </script>
  
  <div on:click={connectViaModal}>
    <slot><button class="button">Connect wallet</button></slot>
  </div>
  
  <style>
  </style>